import PropTypes from 'prop-types'
import { StyledBodyCell } from 'baseui/table-grid'
import useComments from './useComments'

const CommentRow = ({ comments }) => {
  const { t, commentStyle, displayContentStyle, dateStyle } = useComments()

  if (comments.length === 0) {
    return (
      <div role='row' className={displayContentStyle}>
        <StyledBodyCell>
          <span className={commentStyle}>{t('subscriptionTable:no_comments')}</span>
        </StyledBodyCell>
      </div>
    )
  }

  const reversedComments = [...comments].reverse()

  return reversedComments.map((row, index) => {
    const striped = index % 2 === 0
    const date = row.created_at ? new Date(row.created_at).toLocaleString('fr-FR') : ''
    const createdBy = row.user?.firstname + ' ' + row.user?.name
    return (
      <div role='row' className={displayContentStyle} key={index}>
        <StyledBodyCell $striped={striped}>
          <span className={commentStyle}>{row.comment}</span>
          <span className={dateStyle}>{date}</span>
          <span className={dateStyle}>{createdBy}</span>
        </StyledBodyCell>
      </div>
    )
  })
}

CommentRow.propTypes = {
  comments: PropTypes.array,
}

export default CommentRow
